import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const exportVehiclesPDF = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/vehicles/export/pdf?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        responseType: 'blob'
    });

export const exportVehiclesExcel = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/vehicles/export/excel?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        responseType: 'blob'
    });
